
class Request {

    constructor(method, url, params=null, body=null) {
        this.method=method;
        this.url=url;
        this.params=params;
        this.body=body;
        this.xhr = new XMLHttpRequest();
    }

    getRequestUrl(){
        let params = this.getParsedParams();
        let separator;
        if(this.url.includes("?"))
            separator = "&";
        else
            separator = "?";

        return this.url+separator+params;
    }

    getParsedParams(){
        switch (typeof this.params) {
            case "object":
                return Object.keys(this.params)
                    .map(paramName=>paramName+"="+(this.params[paramName]))
                    .join("&");
            case "string":
                return this.params;
            default:
                return "";
        }
    }

    getResponse(){
        return {
            status: this.xhr.status,
                data: this.getResponseData(),
            headers: this.xhr.getAllResponseHeaders(),
        };

    }

    isSuccessFull(){
        return this.xhr.status === 200 ||this.xhr.status === 201
    }

    getResponseData(){
        try{
            return JSON.parse(this.xhr.response);
        }catch (e) {
            return this.xhr.responseType;
        }
        /*console.log(this.xhr.responseType);
        return this.xhr.response*/
    }

    async doRequest(){
        this.xhr.open(this.method, this.getRequestUrl(), false)
        this.xhr.send(this.body);

        if(this.isSuccessFull()){
            return this.getResponse();
        }else{
            throw new RequestError("Request ended with error status.", this.getResponse());
        }
    }
}

class RequestError extends Error{

    constructor(message, response) {
        super();
        this.message = message;
        this.response = response;
    }
}

const request = {
    get(url, params=null){
        return (new Request('GET', url, params, null)).doRequest();
    },

    post(url, params=null, body=null){
        return (new Request('POST', url, params, body)).doRequest();
    },

    put(url, params=null, body=null){
        return (new Request('PUT', url, params, body)).doRequest();
    },

    delete(url, params=null, body=null){
        return (new Request('DELETE', url, params, body)).doRequest();
    },

    doRequest(method, url, params=null, body=null){
        return (new Request(method, url, params, body)).doRequest();
    },

};

export default request;
